import { baseUrl } from './baseUrl';

export const getRel = (relOverride: string | undefined, url: string) => {
    const domain = new URL(url).hostname;
    const ourDomain = new URL(baseUrl()).hostname;

    let rel: string | undefined;

    if (relOverride === 'dofollow') {
        rel = undefined;
    } else if (relOverride === 'nofollow') {
        rel = 'nofollow';
    } else if (relOverride === 'default' || !relOverride) {
        if (domain !== ourDomain) {
            rel = 'nofollow';
        } else {
            rel = undefined;
        }
    }

    return rel;
};
